import { getStatistics, selectState } from "../slices/dtStatistics.slice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import Loader from "components/Loader/Loader";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import DateSelector from "Dashboard/components/DateSelector";
import { FormatDateIso } from "utils/dateUtils";

export const StatisticPreview = () => {
  const { statistics, loading } = useSelector(selectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      dispatch(getStatistics({
        dateFrom: FormatDateIso(dateFrom),
        dateTo: FormatDateIso(dateTo),
      }));
    }
  }, [dispatch, dateFrom, dateTo]);

  return (
    <div className="daily-table-statistics">
      {loading && <Loader />}
      <div className="singleStatistic">
        <div className="statisticsHeader">
          <span>statistika - </span><span> UKUPNO</span>
        </div>
        <div className="statisticsContent">
          <p>{FormatNumberWithUnitOrNull(statistics?.totals.stockValue, 'rsd')} - {FormatNumberWithUnitOrNull(statistics?.totals.stockItems, 'artikala')} - vrednost Lagera.</p>
          <p>{FormatNumberWithUnitOrNull(statistics?.totals.consumablesValue, 'rsd')} - vrednost Potrošnog materijala.</p>
          <p>{FormatNumberWithUnitOrNull(statistics?.totals.fuelInConsumablesLiters, 'l')} goriva - {FormatNumberWithUnitOrNull(statistics?.totals.lubeInConsumablesLiters, 'l')} maziva
            - {FormatNumberOrNull(statistics?.totals.filtersInConsumables)} filteri - {FormatNumberOrNull(statistics?.totals.replacementPartsInConsumables)} rezervni delovi - {FormatNumberOrNull(statistics?.totals.restInConsumables)} ostalo</p>
          <p>{FormatNumberOrNull(statistics?.totals.vehiclesInResources)} vozila - {FormatNumberOrNull(statistics?.totals.mechanizationInResources)} mehanizacija - {FormatNumberOrNull(statistics?.totals.manualMachinesInResources)} ručne mašine
            - {FormatNumberOrNull(statistics?.totals.accessoriesInResources)} dodatna oprema - {FormatNumberOrNull(statistics?.totals.restInResources)} ostalo.</p>
          <p>{FormatNumberOrNull(statistics?.totals.employees)} - broj Zaposlenih.</p>
        </div>
      </div>
      <div className="singleStatistic">
        <div className="statisticsHeader">
          <span>statistika - </span><span> <DateSelector showYear={false} selectDate={selectDate} /></span>
        </div>
        <div className="statisticsContent green">
          <p>{FormatNumberWithUnitOrNull(statistics?.period.valueOfStockOutputItemsInPeriod, 'rsd')} - {FormatNumberWithUnitOrNull(statistics?.period.quantityOfStockOutputItemsInPeriod, 'artikala')} - vrednost izdatog Lagera.</p>
          <p>{FormatNumberWithUnitOrNull(statistics?.period.consumablesValue, 'rsd')} - {FormatNumberWithUnitOrNull(statistics?.period.fuelFromConsumablesLiters, 'l')} goriva - {FormatNumberWithUnitOrNull(statistics?.period.lubeFromConsumablesLiters, 'l')} maziva izdato.</p>
          <p>{FormatNumberWithUnitOrNull(statistics?.period.valueOfServicesAndRepairs, 'rsd')} - {FormatNumberWithUnitOrNull(statistics?.period.numberOfServices, 'servisa')} - {FormatNumberWithUnitOrNull(statistics?.period.numberOfRepairs, 'popravki')}.</p>
          <p>{FormatNumberWithUnitOrNull(statistics?.period.valueOfRegistrations, 'rsd')} - {FormatNumberWithUnitOrNull(statistics?.period.numberOfRegistrations, 'registracija')}.</p>
          <p>{FormatNumberOrNull(statistics?.period.workHours)} Radnih sati.</p>
        </div>
      </div>
    </div>
  );
};
